import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Domains from './pages/Domains';
import Account from './pages/Account';
import Pricing from './pages/Pricing';
import Billing from './pages/Billing';
import NotFound from './pages/NotFound';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Features from './pages/Features';
import Contact from './pages/Contact';
import About from './pages/About';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Notifications from './pages/Notifications';
import CertificateDetails from './pages/CertificateDetails';
import Documentations from './pages/Documentations';
import TeamsIntegrationDocs from './pages/TeamsIntegrationDocs';
import SlackIntegrationDocs from './pages/SlackIntegrationDocs';
import SMSIntegrationDocs from './pages/SMSIntegrationDocs';
import APIDocumentation from './pages/APIDocumentation';

function App() {
  return (
    <Router>
      <AuthProvider>
        <SubscriptionProvider>
          <div className="flex flex-col min-h-screen bg-slate-50">
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/features" element={<Features />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/about" element={<About />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:id" element={<BlogPost />} />
                <Route 
                  path="/dashboard" 
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/domains" 
                  element={
                    <ProtectedRoute>
                      <Domains />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/domains/:serial_number" 
                  element={
                    <ProtectedRoute>
                      <CertificateDetails />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/account" 
                  element={
                    <ProtectedRoute>
                      <Account />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/billing" 
                  element={
                    <ProtectedRoute>
                      <Billing />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/notifications" 
                  element={
                    <ProtectedRoute>
                      <Notifications />
                    </ProtectedRoute>
                  } 
                />
                <Route path="/documentations" element={<Documentations />} />
                <Route path="/documentations/teams-integration" element={<TeamsIntegrationDocs />} />
                <Route path="/documentations/slack-integration" element={<SlackIntegrationDocs />} />
                <Route path="/documentations/sms-integration" element={<SMSIntegrationDocs />} />
                <Route path="/documentations/api-documentation" element={<APIDocumentation />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <Toaster position="top-right" />
        </SubscriptionProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;